module.exports = __webpack_public_path__ + "static/media/sheroes-white-logo.d7c64146.svg";